import UserAttributesApi from './UserAttributesApi';
export default UserAttributesApi;
